import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, Typography } from "antd";

import MMSSetting from "components/settings/MMSSetting";
import VoiceSetting from "components/settings/VoiceSetting";
const { Text, Link } = Typography;

const NumberSettingTab = props => {
  const {
    voiceSettingRef,
    mmsSettingRef,
    voiceSettingFormRef,
    isViewForm,
    numberSelected,
    protocolListSelected,
  } = props;
  const { t } = useTranslation();
  const [tabSelected, setTabSelected] = useState("sms");

  useEffect(() => {
    // Check if protocol unselected and set the tab to the protocol
    setTabSelected(protocolListSelected[protocolListSelected?.length - 1]);
  }, [protocolListSelected]);

  const handleTabChange = key => {
    setTabSelected(key);
  };

  const itemsTab = [
    {
      key: "sms",
      label: t("channelProvider.sms"),
      children: <Text>{t("numbers.noSmsSettings")}</Text>,
      disabled: protocolListSelected?.includes("sms") ? false : true,
    },
    {
      key: "mms",
      label: t("channelProvider.mms"),
      children: (
        <MMSSetting
          ref={mmsSettingRef}
          isView={isViewForm}
          serviceSelected={numberSelected}
        />
      ),
      disabled: protocolListSelected?.includes("mms") ? false : true,
    },
    {
      key: "whatsapp",
      label: t("channelProvider.whatsapp"),
      children: (
        <div>
          <Text>{`${t("numbers.requestAccessWhatsApp")}: `}</Text>
          <Link href="mailto:support@messageclub.com" target="_blank">
            support@messageclub.com
          </Link>
        </div>
      ),
      disabled: protocolListSelected?.includes("whatsapp") ? false : true,
    },
    {
      key: "voice",
      label: t("channelProvider.voice"),
      children: (
        <VoiceSetting
          ref={voiceSettingRef}
          voiceSettingFormRef={voiceSettingFormRef}
          serviceIdSelected={numberSelected?.id}
          disabled={isViewForm}
        />
      ),
      disabled: protocolListSelected?.includes("voice") ? false : true,
    },
  ];

  return (
    <div>
      <Tabs
        activeKey={tabSelected}
        items={itemsTab}
        onChange={handleTabChange}
      />
    </div>
  );
};

export default NumberSettingTab;
